module.exports = __webpack_public_path__ + "img/checkbox-unchecked.svg";